import React from 'react';
import { useNavigate } from 'react-router-dom';

const AmenityServiceCard = ({ service, onBookClick }) => {
  const navigate = useNavigate();

  const handleBookClick = () => {
    if (service.isrelatedtofood) {
      // Navigate to food service page if the service is related to food
      navigate('/reservation/options/booking/welcome/food-service');
    } else {
      // Call the provided function for other services
      onBookClick(service);
    }
  };

  return (
    <div className="relative bg-white rounded-lg shadow-md overflow-hidden flex flex-col h-full">
      {/* Availability Badge (Top-Right) */}
      <span
        className={`absolute top-3 right-3 px-3 py-1 text-sm font-semibold rounded-full ${
          service.isactive ? 'bg-green-500 text-white' : 'bg-red-500 text-white'
        }`}
      >
        {service.isactive ? 'Available' : 'Unavailable'}
      </span>

      {/* Image */}
      <div className="h-72 overflow-hidden">
        <img src={service.imageurl} alt={service.name} className="w-full h-full object-cover" />
      </div>

      {/* Card Content - Grows to fill space */}
      <div className="flex-1 flex flex-col p-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">{service.name}</h2>
        <p className="text-gray-600 mb-4 flex-1">{service.description}</p>

        {/* Booking Button (Sticky at bottom) */}
        <button
          onClick={handleBookClick}
          disabled={!service.isactive}
          className={`w-full mt-4 py-2 px-4 rounded-md transition duration-300 ${
            service.isactive
              ? 'bg-black text-white font-semibold hover:text-gray-300'
              : 'bg-gray-400 text-gray-700 font-semibold cursor-not-allowed'
          }`}
        >
          Book Service
        </button>
      </div>
    </div>
  );
};

export default AmenityServiceCard;
